import React, { Fragment } from "react"
import { Route, Switch } from "react-router"
import styled from "styled-components"
import { setTheme } from "./store/action"
import { connect } from "react-redux"

import Header from "./views/Header"
import Menu from "./components/Menu"
import MenuView from "./views/SideMenu/MenuView"
import Home from "./views/Home"
import config from "./Config"

const Wrapper = styled.div`
  display: flex;
  height: 56px;
  background-color: #000000;
`

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      test: "test",
    }
  }

  componentDidMount() {
    const host = window.location.host
    const getSkin = async () => {
      // const response = await fetch(`http://${host}/skinTheam`)
      const response = await fetch(`${config.NETWORK_URL}/skin`)
      console.log("skin response", response)
      const json = await response.json()
      console.log("skin json", json)
      localStorage.setItem("skinTheme", JSON.stringify(json))
      this.props.setTheme(json)
    }
    getSkin()
  }

  render() {
    // console.log("theme", this.props.theme)
    console.log("main props", this.props)
    const { theme } = this.props

    return (
      <Fragment>
        <Wrapper style={{ backgroundColor: theme.primaryColor }}>
          <Menu>
            <MenuView />
          </Menu>
          <Header freeBids={true} />
        </Wrapper>
        <Switch>
          <Route path='/play/' component={Home} />
        </Switch>
      </Fragment>
    )
  }
}

export default (Main = connect(
  (state, ownProps) => {
    return {
      theme: state.theme,
    }
  },
  {
    setTheme,
  }
)(Main))



// WEBPACK FOOTER //
// ./src/Main.js